import { ViewState } from 'react-map-gl/mapbox';

import { GeographyType, PriorityGroup } from './types';

export const mapboxAccessToken = import.meta.env.VITE_MAPBOX_ACCESS_TOKEN || '';

export const mapboxMapStylesLinks = {
  light: 'mapbox://styles/mapbox/light-v10',
  dark: 'mapbox://styles/mapbox/dark-v10',
};

export const mapboxLabelColors = {
  light: {
    text: '#404040',
    halo: '#FFFFFF',
  },
  dark: {
    text: '#F0F0F0',
    halo: '#1A1A1A',
  },
};

export const countries = ['US', 'MX', 'BR', 'PL'] as const;
type Country = (typeof countries)[number];

export const geographyTypeToTileIdsMap: Record<
  GeographyType,
  Record<
    Country,
    {
      mapboxTileId: string;
      sourceLayer: string;
    } | null
  >
> = {
  PRECISION_AREA: {
    US: {
      mapboxTileId: 'talhaaslam.8h25zfrz',
      sourceLayer: 'new_US',
    },
    MX: {
      mapboxTileId: 'talhaaslam.6zlb48zo',
      sourceLayer: 'new_MX',
    },
    BR: {
      mapboxTileId: 'talhaaslam.arnrwxfs',
      sourceLayer: 'new_BR',
    },
    PL: {
      mapboxTileId: 'talhaaslam.0dukswce',
      sourceLayer: 'new_PL',
    },
  },
  DMA: {
    US: {
      mapboxTileId: 'talhaaslam.bvaogi11',
      sourceLayer: 'dma_USA',
    },
    MX: null,
    BR: null,
    PL: null,
  },
};

export const initialMapViewState: ViewState = {
  longitude: -95.84933749999999,
  latitude: 38.14403568429407,
  zoom: 2.1820207965983816,
  pitch: 0,
  bearing: 0,
  padding: {
    top: 20,
    bottom: 20,
    left: 20,
    right: 20,
  },
} as const;

export const priorityGroupsNames: Record<PriorityGroup, string> = {
  L: 'Low',
  M: 'Medium',
  H: 'High',
  VH: 'Very High',
};

export const getCountryLabel = (code: string): string =>
  new Intl.DisplayNames(['en'], { type: 'region' }).of(code) ?? code;

export const performanceMonitoringFlagsDescription = {
  'CPM instability':
    'Current CPM is tracking above the baseline, suggesting unstable or inefficient delivery.',
  'Sub-optimal imp. distribution':
    'Higher-priority groups are receiving fewer impressions than lower-priority groups, indicating the distribution is off.',
  'Supply constraint':
    'Available supply is too limited for optimization to work effectively, which may impact performance.',
};

export function getNormalizedHeadroomValue(headroomValue: number | null) {
  return headroomValue === null || headroomValue === 0
    ? 0
    : Math.abs(headroomValue - 1) * 100;
}

export const OFFLINE_SALES_OPTMIZER_MODES = {
  STANDARD: 'Standard',
  SALES: 'Sales',
  PENETRATION: 'Penetration',
};

export type TOfflineSalesOptimizerModes =
  (typeof OFFLINE_SALES_OPTMIZER_MODES)[keyof typeof OFFLINE_SALES_OPTMIZER_MODES];
